<script lang="ts" setup>
import { useThemeStoreRef } from '@/stores';
import ButtonComp from './Basic/ButtonComp.vue';
import { computed } from 'vue';

const { currentTheme } = useThemeStoreRef();

const icontext = computed(() => {
    return currentTheme.value == 'dark' ? 'fa-sun-bright' : 'fa-moon';
});
</script>

<template>
    <ButtonComp
        button-type="Secondary"
        :icon="icontext"
        @click.stop="currentTheme = currentTheme == 'dark' ? 'light' : 'dark'"
    />
</template>
